"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const fdr_regular_fusion_fdr_catalogs_card_1 = require("@hotelplan/fdr.regular.fusion.fdr-catalogs-card");
const fdr_lib_misc_catalogs_1 = require("@hotelplan/fdr.lib.misc.catalogs");
const fdr_catalogs_list_styles_1 = require("./fdr-catalogs-list.styles");
const FdrCatalogsList = props => {
    const { orderedCatalogs, catalogs, onAdd, onRemove, cardConfig } = props;
    return (react_1.default.createElement(react_1.default.Fragment, null, (0, fdr_lib_misc_catalogs_1.mapCatalogsToVariantsItems)(catalogs).map((item, i) => {
        const ordered = (0, fdr_lib_misc_catalogs_1.isCatalogOrdered)(item, orderedCatalogs);
        const position = i + 1;
        return (react_1.default.createElement(fdr_catalogs_list_styles_1.CatalogCardWrap, { key: i },
            react_1.default.createElement(fdr_regular_fusion_fdr_catalogs_card_1.FdrCatalogsCard, Object.assign({}, item, { position: position, onOrder: () => ordered ? onRemove(item, position) : onAdd(item, position), ordered: ordered, cardConfig: cardConfig }))));
    })));
};
exports.default = FdrCatalogsList;
//# sourceMappingURL=fdr-catalogs-list.js.map